/**
 * @fileoverview GET handler for the "/engagement/canvas_message_variations_for_uco/:canvas_id/:step_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasMessageVariationsForUcoCanvasIdStepId } from "./constants";
import type { EngagementCanvasMessageVariationsForUcoCanvasIdStepIdResult } from "./types";
import { isEngagementCanvasMessageVariationsForUcoCanvasIdStepIdResult } from "./validators";

export const getEngagementCanvasMessageVariationsForUcoCanvasIdStepId = reactQueryFetcherAdapter(
  engagementCanvasMessageVariationsForUcoCanvasIdStepId,
  (
    signal: AbortSignal,
    canvasId: string,
    stepId: string
  ): Promise<EngagementCanvasMessageVariationsForUcoCanvasIdStepIdResult> => {
    return fetch(`/engagement/canvas_message_variations_for_uco/${canvasId}/${stepId}`, "GET", {}, { signal });
  },
  isEngagementCanvasMessageVariationsForUcoCanvasIdStepIdResult
);
